import {FrontWebSongModel, FrontWebSongRadioModel} from  "../../../generated";
import SongCss from "../Style.module.scss";
import {LogoRow} from "../Image/LogoRow";
import React, {useState} from "react";
import {usePlayOrStop} from "../../Player";
import routes from "../../../utils/routes";
import { RouteLink } from "../../RouteLink";
import {LyricsLink} from "./LyricsLink";

export const SongRow = (props: {
    song: FrontWebSongModel|FrontWebSongRadioModel,
    className?: string
    multiple?: boolean,
}) => {
    const {
        interpret,
        song,
        beginAt,
        image,
        lyricsRadioSlug
    } = props.song;

    const { play } = usePlayOrStop("radio" in props.song ? props.song.radio :  null);
    const [showPlay, setShowPlay] = useState(false);

    const content = <>
        <LogoRow showPlay={showPlay}  src={image || "https://cdb.radia.cz/design/img/thumbnails/no-artwork-image(image400).png"} alt={`${interpret}, ${song}`} />
        {!("radio" in props.song) ?
            <span className={`ms-4 align-self-center ${props.multiple ? "d-none d-sm-block d-mxd-block d-md-none d-lg-block" : "d-none d-mxd-block"} ${SongCss.Time}`}>{beginAt.split("T")[1].replace(/:[0-9]+(([+-]).+)?$/, '')}</span> :
            null}
        <div className="ms-4 align-self-center">
            {!("radio" in props.song) ?
                <span className={`${SongCss.Time} ${props.multiple ? "d-block d-sm-none d-mxd-none d-md-block d-lg-none" : "d-block d-mxd-none"}`}>{beginAt.split("T")[1].replace(/:[0-9]+(([+-]).+)?$/, '')}</span>
                : null}
            <div><strong>{interpret}</strong></div>
            <div>{song}</div>
            {"radio" in props.song ? <div>{props.song.radio.name}</div> : null}
        </div>
    </>

    if ("radio" in props.song) {
        return <RouteLink  onMouseEnter={()=>{
            setShowPlay(true)
        }} onMouseLeave={()=>{
            setShowPlay(false);
        }} onClick={e=>{
            play();
        }} to={routes.radio_homepage(props.song.radio.slug)} className={`d-flex ${SongCss.LinkRow} flex-row ${props.className ?? ""}`}>
            {content}
        </RouteLink>
    } else if (lyricsRadioSlug) {
        return <LyricsLink song={props.song} className={"mb-4"}>
            {content}
        </LyricsLink>
    } else {
        return <div className={`d-flex ${SongCss.LinkRow} flex-row ${props.className ?? ""}`}>
            {content}
        </div>
    }
}